import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import VeeValidate, { Validator } from 'vee-validate'
// import './registerServiceWorker'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Notifications from 'vue-notification'
import VueI18n from 'vue-i18n'
import { translations } from '@/translations/translation_bg'
import vvlocale from 'vee-validate/dist/locale/bg';
import 'vue-search-select/dist/VueSearchSelect.css'

// config
export const globalStore = new Vue({
  data: {
    // API_BASE_URL: 'http://localhost:8000/',
    API_BASE_URL: 'https://amica-group.bg/5yearwarranty/api/public/index.php/',
    IMPLEMENTATION_ID: 14,
    IMPLEMENTATION_COMPANY: "amica" // "amica", "hansa"
  }
})

// axios configuration
Axios.defaults.headers.common['Implementation-Id'] = globalStore.IMPLEMENTATION_ID

vvlocale.messages.required = 'Задължително поле'
vvlocale.messages.regex = 'Форматът на полето е неправилен'
vvlocale.messages.min = 'Серийният номер трябва да съдържа поне 14 цифри'

Validator.localize({ bg: vvlocale })
const vvconfig = {
  locale: 'bg'
}

Vue.config.productionTip = false
Vue.use(VeeValidate, vvconfig)
Vue.use(VueAxios, Axios)
Vue.component('icon', Icon)
Vue.use(Notifications)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'bg',
  messages: translations
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
